export enum Permission {
    SMP_CASE_DELETE = 'smp_case_delete',
    SMP_CASE_EDIT = 'smp_case_edit',
    SMP_CASE_EDIT_ASSESSOR_SECTION = 'smp_case_edit_assessor_section',
    SMP_CASE_EDIT_LAWYER_SECTION = 'smp_case_edit_lawyer_section',
    SMP_CASE_OVERVIEW_WIDGET = 'smp_case_overview_widget',
    SMP_CASE_SWITCH_VIEW = 'smp_case_switch_view',
    SMP_SETTINGS = 'smp_settings',
    SUPPORT_ADMIN = 'support_admin',
    SUPPORT_USER = 'support_user',
    INBOX_WIDGET = 'inbox_widget',
    INBOX_REJECT = 'inbox_reject',
    INBOX_DELETE = 'inbox_delete',
    INBOX_FORWARD = 'inbox_forward'
}

export enum Role {
    SMP_ADMIN = 'smp_admin',
    SMP_ASSESSOR = 'smp_assessor',
    SMP_LAWYER = 'smp_lawyer',
    SMP_SALES_MANAGER = 'smp_salesmanager',
    SMP_SERVICE_CONSULTANT = 'smp_serviceconsultant',
    SMP_TYPIST = 'smp_typist',
    SMP_USER = 'smp_user'
}

export enum Module {
    MODULE_DYNAREX_PLUS = "module_dynarex_plus",
    MODULE_IMPORT =  "module_import",
    MODULE_SIGNING =  "module_signing",
    MODULE_WORKFLOW = "module_workflow",
    SMP_BASIC =  "smp_basic"
}

export enum Page {
    PAGE_DASHBOARD                                  = 'DASHBOARD',
    PAGE_CONNECT_PORTAL_AUTH                        = 'CONNECT_PORTAL_AUTH',
    PAGE_CONNECT_PORTAL_CASE                        = 'CONNECT_PORTAL_CASE',
    
    PAGE_ACCOUNTING                                 = 'ACCOUNTING',
    PAGE_ACCOUNTING_DUNNING                         = 'ACCOUNTING_DUNNING',
    PAGE_ACCOUNTING_PAYMENT                         = 'ACCOUNTING_PAYMENT',
    PAGE_ACCOUNTING_INVOICE                         = 'ACCOUNTING_INVOICE',
    PAGE_ACCOUNTING_EGUB_IMPORT                     = 'ACCOUNTING_EGUB_IMPORT',
    
    PAGE_CASE                                       = 'CASE',
    PAGE_CASE_VIEW                                  = 'CASE_VIEW',
    PAGE_CASE_EDIT_ADMIN                            = 'CASE_EDIT_ADMIN',
    PAGE_CASE_EDIT_VEHICLE                          = 'CASE_EDIT_VEHICLE',
    PAGE_CASE_EDIT_PARTICIPANTS                     = 'CASE_EDIT_PARTICIPANTS',
    PAGE_CASE_EDIT_CALCULATION                      = 'CASE_EDIT_CALCULATION',
    PAGE_CASE_EDIT_MEDIA                            = 'CASE_EDIT_MEDIA',
    PAGE_CASE_EDIT_SALVAGE                          = 'CASE_EDIT_SALVAGE',
    PAGE_CASE_EDIT_STATE_ASSESSMENT                 = 'CASE_EDIT_STATE_ASSESSMENT',
    PAGE_CASE_EDIT_RESULTS                          = 'CASE_EDIT_RESULTS',
    PAGE_CASE_EDIT_VALUATIONS                       = 'CASE_EDIT_VALUATIONS',
    PAGE_CASE_EDIT_DOCUMENTS                        = 'CASE_EDIT_DOCUMENTS',
    PAGE_CASE_EDIT_TEXT_BLOCKS                      = 'CASE_EDIT_TEXT_BLOCKS',
    PAGE_CASE_EDIT_INVOICES                         = 'CASE_EDIT_INVOICES',
    PAGE_CASE_EDIT_INVOICE                          = 'CASE_EDIT_INVOICE',
    PAGE_CASE_EDIT_MARKET_VALUE                     = 'CASE_EDIT_MARKET_VALUE',

    PAGE_SETTINGS_OFFICES                           = 'SETTINGS_OFFICES',
    PAGE_SETTINGS                                   = 'SETTINGS',
    PAGE_SETTINGS_CREDENTIALS                       = 'SETTINGS_CREDENTIALS',
    PAGE_SETTINGS_EMAIL                             = 'SETTINGS_EMAIL',
    PAGE_SETTINGS_CONNECT_PORTAL                    = 'SETTINGS_CONNECT_PORTAL',
    PAGE_SETTINGS_TEXT_BLOCKS                       = 'SETTINGS_TEXT_BLOCKS',
    PAGE_SETTINGS_ADDRESS_BOOK                      = 'SETTINGS_ADDRESS_BOOK',
    PAGE_SETTINGS_INVOICES                          = 'SETTINGS_INVOICES',
    PAGE_SETTINGS_INVOICES_MASTER_DATA              = 'SETTINGS_INVOICES_MASTER_DATA',
    PAGE_SETTINGS_INVOICES_GENERAL                  = 'SETTINGS_INVOICES_GENERAL',
    PAGE_SETTINGS_INVOICES_FEE_TABLE                = 'SETTINGS_INVOICES_FEE_TABLE',
    PAGE_SETTINGS_INVOICES_ARTICLE_SETS             = 'SETTINGS_INVOICES_ARTICLE_SETS',
    PAGE_SETTINGS_INVOICES_LIST_DATA                = 'SETTINGS_INVOICES_LIST_DATA',
    PAGE_SETTINGS_DISTRIBUTION_RECIPIENTS           = 'SETTINGS_DISTRIBUTION_RECIPIENTS',
    PAGE_SETTINGS_CASES                             = 'SETTINGS_CASES',
    PAGE_SETTINGS_CASES_CLAIM_TYPES                 = 'SETTINGS_CASES_CLAIM_TYPES',
    PAGE_SETTINGS_CASES_ORDER_TYPES                 = 'SETTINGS_CASES_ORDER_TYPES',
    PAGE_SETTINGS_STATISTICS                        = 'SETTINGS_STATISTICS',
    PAGE_SETTINGS_STATISTICS_GENERAL                = 'SETTINGS_STATISTICS_GENERAL',
    PAGE_SETTINGS_STATISTICS_ACCOUNTING             = 'SETTINGS_STATISTICS_ACCOUNTING',
    PAGE_SETTINGS_DUNNINGS                          = 'SETTINGS_DUNNINGS',
    PAGE_SETTINGS_PAYMENTS                          = 'SETTINGS_PAYMENTS',
    PAGE_SETTINGS_USERS                             = 'SETTINGS_USERS',
    PAGE_SETTINGS_USERS_USERS                       = 'SETTINGS_USERS_USERS',
    PAGE_SETTINGS_USERS_PERMISSIONS                 = 'SETTINGS_USERS_PERMISSIONS',
    PAGE_SETTINGS_TEMPLATES                         = 'SETTINGS_TEMPLATES',
    PAGE_SETTINGS_DEPARTMENTS                       = 'SETTINGS_DEPARTMENTS',
    PAGE_SETTINGS_INSIGN                            = 'SETTINGS_INSIGN',
    PAGE_SETTINGS_STATE_ASSESSMENT                  = 'SETTINGS_STATE_ASSESSMENT',
    PAGE_SETTINGS_STATE_ASSESSMENT_CHECK_POSITIONS  = 'SETTINGS_STATE_ASSESSMENT_CHECK_POSITIONS',
    PAGE_SETTINGS_STATE_ASSESSMENT_SCHEMES          = 'SETTINGS_STATE_ASSESSMENT_SCHEMES',
}

export enum LogicOp {
    AND,
    OR,
    NAND,
    NOR
}
